<template>
  <el-upload
      action="#"
      multiple
      :list-type="listType"
      :accept="accept"
      :show-file-list="showFileList"
      :on-change="saveFile"
      :on-remove="removeFile"
      :file-list="fileList"
      :auto-upload="false">
    <slot name="button"></slot>
  </el-upload>
</template>

<script>
  /**
   * @description 文件上传组件 目前逻辑只上传一个文件
   * @author: 菩萨蛮
   * @date 2019/11/13 3:58 下午
   * @version V1.0.1
   *
   * 公司的业务千篇一律，复杂的代码好几百行
   * TODO: 最多上传几件提示，只有一件的时候替换操作
   * TODO: 重复上传功能
   *
   * V1.0.1 修复保存系统问题，添加是否保留文件字段
   */

  export default {
    name: 'QxUpload',
    props: {
      accept: { type: String, default: '.jpg,.jpeg,.png,.bmp,.pdf,.doc,.docx,.rar' },
      listType: { type: String, default: 'text' },
      value: { type: String },
      maxSize: { type: Number, default: 10 },
      defaultUrl: { type: String },
      keepFile: { type: Boolean, default: true },
      showFileList: { type: Boolean, default: true },
      systemType: { type: Number, default: 6 }
    },
    data() {
      return {
        fileList: []
      };
    },
    methods: {
      beforeUpload(file) {
        const isLtSize = file.size <= this.maxSize * 1024 * 1024;
        if (!isLtSize) {
          this.$message.error(`上传文件大小不能超过${this.maxSize}MB!`);
          return false;
        }
        return true;
      },
      async saveFile(file, fileList) {
        if (!this.beforeUpload(file.raw)) {
          this.fileList = [];
          return;
        }
        const form = new FormData();
        form.append('file', file.raw);
        form.append('companyId', JSON.parse(localStorage.getItem('user')).companyId);
        // form.append('systemType', this.CONSTANT.SYSTEM_TYPE);
        form.append('systemType', this.systemType);
        const response = await this.qPost({
          url: '/dfs/file',
          data: form
        });
        if (response.code === 200) {
          if(this.keepFile){
            this.fileList = fileList;
          }else{
            this.$emit('uploadedFile', {
              file:file,
              url:`/${response.data.path}`
            });
          }
          // 暂时默认就一个
          this.$emit('update:value', `/${response.data.path}`);
        } else {
          this.$message.error(response.msg);
        }
      },
      // addFile(files, fileList) {
      //   if (files.length !== 1 || !this.beforeUpload(files[0])) {
      //     return;
      //   }
      //   if (this.keepFile){
      //     this.fileList = [...files];
      //   }
      //   const f = files[0];
      //   const file = {
      //     name: f.name,
      //     raw: f,
      //     size: f.size,
      //     status: 'ready',
      //     uid: f.uid
      //   };
      //   this.saveFile(file, [...files]);
      // },
      removeFile() {
        this.$emit('update:value', this.defaultUrl || '');
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
